/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    onPauseEvent,
    onResumeEvent,
} from '../../store/visibilityevents/visibilityevents.reducers';

import { Log } from '../../core/logging/Log';

const VisibilityEvents: FunctionComponent = (): JSX.Element => {
    const TAG = 'VisibilityEvent';
    const dispatch = useDispatch();

    const visibilityHandler = () => {
        Log.i(TAG, 'visibilitychange', document.hidden);
        if (document.hidden) {
            Log.i(TAG, 'onpause');
            dispatch(onPauseEvent());
        } else {
            Log.i(TAG, 'onResume');
            dispatch(onResumeEvent());
        }
    };

    useEffect(() => {
        Log.i(TAG, 'visibilitychange event register');
        document.addEventListener('visibilitychange', visibilityHandler, false);
        return () => {
            Log.i(TAG, 'visibilitychange event un register');
            document.removeEventListener('visibilitychange', visibilityHandler, false);
        };
    }, []);

    return <></>;
};

export default VisibilityEvents;
